import React from "react";
import styled from "styled-components";
import { Card } from "../../Card";
import { LoadingSpinner, SpinnerSize } from "../../LoadingSpinner";
export const InfoPanel = (props) => {
    const { rowSpan, columnSpan, children, isLoading } = props;
    return (React.createElement(Container, { rowSpan: rowSpan, columnSpan: columnSpan },
        isLoading && (React.createElement(LoadingWrapper, null,
            React.createElement(LoadingSpinner, { size: SpinnerSize.SMALL }))),
        !isLoading && children));
};
const Container = styled(Card) `
  padding: ${({ theme: { space } }) => `${space[3]}px`};

  @media screen and (min-width: ${({ theme: { breakpoints } }) => breakpoints[0]}) {
    grid-row: auto / span 1;
    grid-column: auto / span 6;
  }

  @media screen and (min-width: ${({ theme: { breakpoints } }) => breakpoints[3]}) {
    grid-row: ${({ rowSpan }) => (rowSpan ? `auto / span ${rowSpan}` : "auto")};
    grid-column: ${({ columnSpan }) => (columnSpan ? `auto / span ${columnSpan}` : "auto")};
  }
`;
const LoadingWrapper = styled.div `
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
